var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-8 w-full px-4 flex items-center justify-center",attrs:{"id":"backState"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('goBack')}}},[_vm._v(" Go Back ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }